/**
 * Pure formatters voor de /items overzicht- en detail-pagina's.
 * Geen state, geen side-effects — testbaar.
 */

export function formatDimensions(item: {
  vorm: string;
  lengteCm?: number | null;
  breedteCm?: number | null;
  diameterCm?: number | null;
  areaM2?: number | null;
}): string {
  if (item.vorm === 'Rond' && item.diameterCm) {
    return `Ø ${item.diameterCm} cm`;
  }
  if (item.vorm === 'Anders') {
    return item.areaM2 ? `${item.areaM2.toFixed(2)} m²` : '—';
  }
  if (item.lengteCm && item.breedteCm) {
    return `${item.lengteCm}×${item.breedteCm} cm`;
  }
  return '—';
}

export function formatPackageLabel(label: string | null): string {
  return label && label.trim().length > 0 ? label : '—';
}

export function formatExtrasCount(count: number): string {
  return count > 0 ? `+${count}` : '—';
}
